import { io, Socket } from "socket.io-client";

export const socketInit = (userId: string, token: string) => {
  // console.log("token", token);
  return io(import.meta.env.VITE_JIGSAW_DEV_REST_LOCATION, {
    timeout: 10000,
    transports: ["websocket"],
    query: {
      userId,
    },
    auth: {
      token: token,
    },
  });
};
